import { S1CloudProvider, S1CloudProviderData } from 'common/graphqlTypes';
import EndpointCloudProviderSection from './EndpointCloudProviderSection';
import { CLOUD_PROVIDER, CloudProviderConfiguration } from './types';
import { CloudProvidersConfigurations } from './consts';

import './EndpointCloudProviderTab.scss';

export type EndpointCloudProviderTabProps = {
  cloudProvidersData: S1CloudProvider[];
};

/**
 * This component displays endpoint's cloud providers tab.
 *
 * @prop cloudProvidersData array of endpoint's cloud providers
 */
function EndpointCloudProvidersTab({ cloudProvidersData }: EndpointCloudProviderTabProps): JSX.Element {
  const sectionsConfigurationAndData = cloudProvidersData
    .filter((s1CloudProvider) => CloudProvidersConfigurations[s1CloudProvider.name as CLOUD_PROVIDER]?.isSupported)
    // map the sections to data - configuration pair.
    .map((s1CloudProvider) => ({
      sectionConfiguration: CloudProvidersConfigurations[s1CloudProvider.name as CLOUD_PROVIDER],
      sectionData: s1CloudProvider.value,
    }))
    // making sure all needed data is available
    .filter(({ sectionConfiguration, sectionData }) => sectionConfiguration && sectionData);

  const createEndpointCloudProviderSection = (
    sectionConfiguration: CloudProviderConfiguration,
    sectionData: S1CloudProviderData,
  ) =>
    sectionData && (
      <div key={sectionConfiguration.title} className="EndpointCloudProviderTab__SectionContainer">
        <EndpointCloudProviderSection sectionConfiguration={sectionConfiguration} s1CloudProvidersData={sectionData} />
      </div>
    );

  return (
    <div className="EndpointCloudProviderTab">
      {sectionsConfigurationAndData.map(({ sectionConfiguration, sectionData }) =>
        createEndpointCloudProviderSection(sectionConfiguration, sectionData),
      )}
    </div>
  );
}

export default EndpointCloudProvidersTab;
